<template>
  <div class="Container" v-if="UserProfile === 'SUP'">
    <h2 class="ViewHeading">Board Member User Admin</h2>

    <b-container>
      <h5 class="pageHeader">Select User Admin Action</h5>

      <div class="tab">
        <button
          v-if="selectedAction != 'AddClient'"
          class="reportTabLeft"
          v-on:click="selectedAction = 'AddClient'"
        >
          Add Board Member User
        </button>
        <button
          v-if="selectedAction == 'AddClient'"
          class="reportTabActiveLeft"
          v-on:click="selectedAction = 'AddClient'"
        >
          Add Board Member User
        </button>

        <button
          v-if="selectedAction != 'AddLocation'"
          class="reportTab"
          v-on:click="showModal('BMUSelectLocModal')"
        >
          Add Board Member Location
        </button>
        <button
          v-if="selectedAction == 'AddLocation'"
          class="reportTabActive"
          v-on:click="selectedAction = 'AddLocation'"
        >
          Add Board Member Location
        </button>

        <button
          v-if="selectedAction != 'DeactBMU'"
          class="reportTabRight"
          v-on:click="showModal('BMUDeactivateModal')"
        >
          Remove Board Member User
        </button>
        <button
          v-if="selectedAction == 'DeactBMU'"
          class="reportTabActiveRight"
          v-on:click="selectedAction = 'DeactBMU'"
        >
          Remove Board Member User
        </button>
      </div>

      <div class="tabcontent">
        <span class="SelectionRow" v-if="selectedAction == 'AddClient'">
          <div class="tabBottom">
            <div class="tabcontent">
              <span class="SelectionRow" v-if="selectedAction == 'AddClient'">
                <h3>Board Member User Add Form</h3>

                <b-row>
                  <b-col sm="3">
                    <p id="FormText">First Name</p>
                  </b-col>
                  <b-col sm="3">
                    <input
                      type="text"
                      placeholder="First Name"
                      v-model="fName"
                      required
                      @focus="modal = false"
                    />
                  </b-col>
                  <b-col sm="3">
                    <p id="FormText">Last Name</p>
                  </b-col>
                  <b-col sm="3">
                    <input
                      type="text"
                      placeholder="Last Name"
                      v-model="lName"
                      required
                      @focus="modal = false"
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="3">
                    <p id="FormText">Email</p>
                  </b-col>
                  <b-col sm="3">
                    <input
                      type="text"
                      placeholder="Email"
                      v-model="bmuEmail"
                      required
                      @focus="modal = false"
                    />
                  </b-col>
                </b-row>
                <h5 class="pageHeader">Location Data</h5>
                <b-row>
                  <b-col sm="3">
                    <p id="FormText">Country</p>
                  </b-col>
                  <b-col sm="3">
                    <select v-model="bmuCountry">
                      <option value="" select disabled>Select Location</option>
                      <option
                        v-for="(value, id) in this.countryArray"
                        :key="id"
                        v-bind:value="{ id: value.id, text: value.Country }"
                        >{{ value.Country }}</option
                      >
                    </select>
                  </b-col>

                  <b-col sm="3">
                    <p id="FormText">Region</p>
                  </b-col>
                  <b-col sm="3">
                    <select v-model="bmuRegion">
                      <option value="" select disabled>Select Location</option>
                      <option
                        v-for="(value, id) in this.regionArray"
                        :key="id"
                        v-bind:value="{ id: value.id, text: value.Region }"
                        >{{ value.Region }}</option
                      >
                    </select>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="3">
                    <p id="FormText">Select Location</p>
                  </b-col>
                  <b-col sm="3">
                    <vue-bootstrap-typeahead
                      class="Dropdownautofill"
                      v-model="bmuLocationToAdd"
                      :data="buildingArray"
                    >
                      <!-- Append a button -->
                      <template slot="append">
                        <button
                          id="button"
                          :disabled="this.addNewLocationButton"
                          v-on:click="bmuLocationAddition()"
                          class="autofillButton"
                        >
                          +
                        </button>
                      </template>
                    </vue-bootstrap-typeahead>
                  </b-col>

                  <b-col sm="3">
                    <p id="FormText">List of BMU Locations</p>
                  </b-col>
                  <b-col sm="3">
                    <p
                      v-for="(id, idx) in this.bmuLocationSubmitDisplayObject"
                      :key="idx"
                      id="FormText"
                    >
                      {{ id.Location }}
                    </p>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col>
                    <button
                      id="button"
                      class="AdminButton"
                      @focus="modal = false"
                      v-on:click="submitNewBMUAuth0()"
                    >
                      Submit
                    </button>
                    <button
                      class="AdminButton"
                      @focus="modal = false"
                      v-on:click="resetForm()"
                    >
                      Clear
                    </button>
                  </b-col>
                </b-row>
              </span>
            </div>
          </div>
        </span>

        <span class="SelectionRow" v-if="selectedAction == 'AddLocation'">
          <div class="tabBottom">
            <div class="tabcontent">
              <span class="SelectionRow" v-if="selectedAction == 'AddLocation'">
                <h3>Board Member Add Location Form</h3>
                <b-row>
                  <b-col sm="3">
                    <p id="FormText">Name</p>
                  </b-col>
                  <b-col sm="3">
                    <input
                      type="text"
                      placeholder="Name"
                      v-model="this.bmuSelection[0].Name"
                      required
                      readonly
                      @focus="modal = false"
                    />
                  </b-col>
                  <b-col sm="3">
                    <p id="FormText">Current Locations</p>
                  </b-col>
                  <b-col sm="3">
                    <!--   <input
                  type="text"
                  placeholder="Locations"
                  v-model="bmuToDelete.Locations"
                  required
                  readonly
                  @focus="modal = false"
                /> 
                 <b-form-textarea
                   id="textarea"
                   v-model="bmuToDelete.Locations"
                   >
                 </b-form-textarea> -->

                    <p
                      v-for="(id, idx) in this.bmuSelection[0].Locations"
                      :key="idx"
                      id="FormText"
                    >
                      {{ id }}
                    </p>
                  </b-col>
                </b-row>

                <h5 class="pageHeader">Add New Location</h5>
                <b-row>
                  <b-col sm="3">
                    <p id="FormText">Country</p>
                  </b-col>
                  <b-col sm="3">
                    <select v-model="bmuCountry">
                      <option value="" select disabled>Select Location</option>
                      <option
                        v-for="(value, id) in this.countryArray"
                        :key="id"
                        v-bind:value="{ id: value.id, text: value.Country }"
                        >{{ value.Country }}</option
                      >
                    </select>
                  </b-col>

                  <b-col sm="3">
                    <p id="FormText">Region</p>
                  </b-col>
                  <b-col sm="3">
                    <select v-model="bmuRegion">
                      <option value="" select disabled>Select Location</option>
                      <option
                        v-for="(value, id) in this.regionArray"
                        :key="id"
                        v-bind:value="{ id: value.id, text: value.Region }"
                        >{{ value.Region }}</option
                      >
                    </select>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="3">
                    <p id="FormText">Select Location</p>
                  </b-col>
                  <b-col sm="3">
                    <vue-bootstrap-typeahead
                      class="Dropdownautofill"
                      v-model="bmuLocationToAdd"
                      :data="buildingArray"
                    >
                      <!-- Append a button -->
                      <template slot="append">
                        <button
                          :disabled="this.addNewLocationButton"
                          v-on:click="bmuLocationAddition()"
                          class="autofillButton"
                        >
                          +
                        </button>
                      </template>
                    </vue-bootstrap-typeahead>
                  </b-col>

                  <b-col sm="3">
                    <p id="FormText">List of BMU Locations</p>
                  </b-col>
                  <b-col sm="3">
                    <p
                      v-for="(id, idx) in this.bmuLocationSubmitDisplayObject"
                      :key="idx"
                      id="FormText"
                    >
                      {{ id.Location }}
                    </p>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col>
                    <button
                      id="button"
                      class="AdminButton"
                      @focus="modal = false"
                      v-on:click="bmuLocationAddSubmit()"
                    >
                      Submit
                    </button>
                    <button
                      class="AdminButton"
                      @focus="modal = false"
                      v-on:click="resetForm()"
                    >
                      Clear
                    </button>
                  </b-col>
                </b-row>
              </span>
            </div>
          </div>
        </span>

        <span class="SelectionRow" v-if="selectedAction == 'DeactBMU'">
          <div class="tabBottom">
            <div class="tabcontent">
              <span class="SelectionRow" v-if="selectedAction == 'DeactBMU'">
                <h3>Board Member User Inactivate Form</h3>

                <b-row>
                  <b-col sm="3">
                    <p id="FormText">Name</p>
                  </b-col>
                  <b-col sm="3">
                    <input
                      type="text"
                      placeholder="Name"
                      v-model="bmuToDelete.Name"
                      required
                      readonly
                      @focus="modal = false"
                    />
                  </b-col>
                  <b-col sm="3">
                    <p id="FormText">Locations</p>
                  </b-col>
                  <b-col sm="3">
                    <!--   <input
                  type="text"
                  placeholder="Locations"
                  v-model="bmuToDelete.Locations"
                  required
                  readonly
                  @focus="modal = false"
                /> 
                 <b-form-textarea
                   id="textarea"
                   v-model="bmuToDelete.Locations"
                   >
                 </b-form-textarea> -->

                    <p
                      v-for="(id, idx) in this.bmuToDelete.Locations"
                      :key="idx"
                      id="FormText"
                    >
                      {{ id }}
                    </p>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col>
                    <button
                      id="button"
                      class="AdminButton"
                      @focus="modal = false"
                      v-on:click="deactivateBMU()"
                    >
                      Submit
                    </button>
                    <button
                      class="AdminButton"
                      @focus="modal = false"
                      v-on:click="resetForm()"
                    >
                      Clear
                    </button>
                  </b-col>
                </b-row>
              </span>
            </div>
          </div>
        </span>
      </div>

      <!-------------------------------------------------------------------------------------------------------------------- 
-->
      <b-modal
        ref="BMUDeactivateModal"
        id="BMUDeactivateModal"
        hide-footer
        title=" Board Member User Lookup Form"
        content-class="Modal"
      >
        <div>
          <h3>Search by user's name</h3>
          <input
            maxlength="45"
            type="text"
            v-model="UserFirstNameSearch"
            placeholder="First Name"
          />
          <input
            maxlength="45"
            type="text"
            v-model="UserSurnameSearch"
            placeholder="Last Name"
          />
          <br />
          <button
            id="button"
            class="button"
            v-on:click="LookUpSubmit('BMUDeactivate')"
          >
            Submit
          </button>
          <button id="button" class="button" v-on:click="resetForm()">
            Clear
          </button>
        </div>
      </b-modal>

      <b-modal
        ref="BMUSelectLocModal"
        id="BMUSelectLocModal"
        hide-footer
        title=" Board Member User Lookup Form"
        content-class="Modal"
      >
        <div>
          <h3>Search by user's unique reference</h3>
          <!-- <input
            maxlength="45"
            type="text"
            v-model="UserFirstNameSearch"
            placeholder="First Name"
          />
          <input
            maxlength="45"
            type="text"
            v-model="UserSurnameSearch"
            placeholder="Last Name"
          /> -->
          <input
            maxlength="30"
            type="text"
            v-model="BMUUserURN"
            placeholder="BMU User URN"
          />
          <br />
          <button
            id="button"
            class="button"
            v-on:click="LookUpSubmit('BMUSelectLocModal')"
          >
            Submit
          </button>
          <button id="button" class="button" v-on:click="resetForm()">
            Clear
          </button>
        </div>
      </b-modal>

      <b-modal
        ref="BMUSelectionModal"
        id="BMUSelectionModal"
        hide-footer
        title="Board Member User Selection Form"
        content-class="Modal"
      >
        <div>
          <h3>Select BMU</h3>

          <select v-model="bmuSelection">
            <option value="" select disabled>Select Installer</option>
            <option
              v-for="(value, id) in this.bmuListArray"
              :key="id"
              v-bind:value="{
                UserURN: value.UserURN,
                Name: value.Name,
                Locations: value.Locations,
              }"
              >{{ value.Name + " - " + value.Locations }}</option
            >
          </select>

          <br />
          <button id="button" class="AdminButton" v-on:click="bmuSelect()">
            Submit
          </button>
          <button class="AdminButton" v-on:click="resetForm()">
            Clear
          </button>
        </div>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";

export default {
  components: {
    VueBootstrapTypeahead,
  },

  methods: {
    btnCooldown: function() {
      let buttonid = "button";
      const button = document.querySelector("#" + buttonid + "");
      if (this.buttonCooldown == true) {
        const disableButton = () => {
          button.disabled = true;
        };
        button.addEventListener("click", disableButton);
      } else if (this.buttonCooldown == false) {
        button.disabled = false;
      }
    },
    bmuLocationAddSubmit() {
      let LookUpUrlDB =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/superuser";
      let LookUpHeadersDB = this.$apikeyPost;
      this.LookUpRequest = {
        RequestType: "User",
        Action: "AddBMULoc",
        Type: "BMU",
        DataDict: [
          {
            UserURN: this.bmuSelection[0].UserURN,
            Locations: this.bmuLocationtoSubmit,
          },
        ],
      };
      axios
        .post(LookUpUrlDB, this.LookUpRequest, LookUpHeadersDB)
        .then((response) => {
          response;
          this.HistorySubmit();
          alert("Location has been added");
          this.resetForm();
        });
    },
    showModal(Modal) {
      this.DivID = "";
      this.BMUUserURN = "";
      this.$refs[Modal].show();
    },
    hideModal(Modal) {
      this.$refs[Modal].hide();
    },
    resetForm() {
      this.selectedAction = "";
      this.DivID = "";
      (this.deactclURN = ""),
        (this.deactclFName = ""),
        (this.deactclLName = ""),
        (this.deactclDept = ""),
        (this.deactclLoc = ""),
        (this.fName = ""),
        (this.lName = "");
      this.clDept = "";
      this.clLocation = "";
      this.clEmail = "";
      this.DeviceRequestNo = "";
      this.messageforNewLocationEmail = "";
      this.bmuEmail = "";
      this.bmuCountry = "";
      this.bmuRegion = "";
      this.bmuLocationtoSubmit = "";
      this.bmuLocationSubmitDisplayObject = "";
      this.bmuLocationToAdd = "";
      this.UserFirstNameSearch = "";
      this.UserSurnameSearch = "";
      this.bmuToDelete = "";
    },

    bmuSelect() {
      this.bmuToDelete = this.bmuSelection;
      this.hideModal("BMUSelectionModal");
      this.selectedAction = "DeactBMU";
    },

    deactivateBMU() {
      let LookUpUrlDB =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/superuser";
      let LookUpHeadersDB = this.$apikeyPost;
      this.LookUpRequest = {
        RequestType: "User",
        Action: "Delete",
        Type: "BMU",
        DataDict: [{ UserURN: this.bmuToDelete.UserURN }],
      };
      axios
        .post(LookUpUrlDB, this.LookUpRequest, LookUpHeadersDB)
        .then((response) => {
          response;
          this.HistorySubmit();
          alert("Board Member User has been Inactivated");
          this.resetForm();
        });
    },

    bmuLocationAddition() {
      if (this.selectedAction == "AddClient") {
        this.bmuLocationtoSubmit.push(this.bmuLocationToAdd);
        this.bmuLocationSubmitDisplayObject.push({
          Location: this.bmuLocationToAdd,
        });
        this.bmuLocationToAdd = "";
      } else if (this.selectedAction == "AddLocation") {
        this.bmuLocationtoSubmit.push(this.bmuLocationToAdd);
        this.bmuLocationSubmitDisplayObject.push({
          Location: this.bmuLocationToAdd,
        });
        this.bmuLocationToAdd = "";
      }
    },

    submitNewBMUAuth0() {
      this.buttonCooldown = true;

      var randomNo1 = Math.floor(Math.random() * 9);
      var randomNo2 = Math.floor(Math.random() * 9);
      var randomNo3 = Math.floor(Math.random() * 9);
      var randomNo4 = Math.floor(Math.random() * 9);

      let totalNo = randomNo1.toString(10);
      totalNo = totalNo + randomNo2.toString(10);
      totalNo = totalNo + randomNo3.toString(10);
      totalNo = totalNo + randomNo4.toString(10);
      let nickname = "";
      nickname = "";
      nickname = this.fName.slice(0, 3) + this.lName.slice(0, 3);
      nickname = nickname + totalNo;

      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/auth0";
      let LookUpHeaders = this.$apikeyPost;
      this.LookUpRequest = {
        RequestType: "Create",
        Email: this.bmuEmail,
        UserMetaCompany: "",
        UserMetaLocation: "",
        AppMetaAccess: "BoardMember",
        AppMetaPortal: "BMU",
        FirstName: this.fName,
        LastName: this.lName,
        Name: this.fName + " " + this.lName,
        UserID: "",
        Username: nickname,
      };

      axios
        .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
        .then((response) => {
          this.buttonCooldown = false;

          this.bmuURN = response.data.Values.user_id;
          this.AddNewBMUDB();
        });
    },

    AddNewBMUDB() {
      this.buttonCooldown = true;

      let LookUpUrlDB =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/superuser";
      let LookUpHeadersDB = this.$apikeyPost;
      this.LookUpRequest = {
        RequestType: "User",
        Action: "Create",
        Type: "BMU",
        DataDict: [
          {
            UserURN: this.bmuURN,
            FirstName: this.fName,
            LastName: this.lName,
            Email: this.bmuEmail,
            Locations: this.bmuLocationtoSubmit,
          },
        ],
      };
      axios
        .post(LookUpUrlDB, this.LookUpRequest, LookUpHeadersDB)
        .then((response) => {
          response;
          this.buttonCooldown = false;

          this.HistoryNote = "Added BMU";
          alert("BMU has been created");
        });
    },

    AddNewBMULocation() {
      this.buttonCooldown = true;

      if (this.messageforNewLocationEmail == "") {
        this.buttonCooldown = false;

        alert("Please ensure the text field is not empty");
      } else {
        let newMessage = JSON.stringify(this.messageforNewLocationEmail);
        let newMessage2 = newMessage.replace(/^"|"$/g, "");

        let EmailHPAdd = {
          ToEmail: "support@haloprotect.online",
          EmailText:
            "Hello, \\n\\nThe following User has requested access to a new location. \\n\\nPlease follow up with the appropriate steps.\\nFull Name: " +
            this.userName +
            "\\nMessage From User: " +
            newMessage2 +
            "\\n\\nSent from Seraph Protect",
          EmailSubject: "New Board Member User Location Request ",
        };
        let EmailPosturl =
          "https://d9py0urct8.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/emailgateway";
        let EmailPostHeaders = this.$apikeyPost;
        axios
          .post(EmailPosturl, EmailHPAdd, EmailPostHeaders)
          .then((response) => {
            response;
            this.HistoryNote = "Requested Location";
            this.HistorySubmit();
            this.resetForm();
            this.hideModal("NewLocation");
          })
          .catch((err) => {
            "Error: ===", err;
          });
        this.buttonCooldown = false;

        alert("New Location Requested");
      }
    },

    editLocation() {
      this.buttonCooldown = true;

      let LookUpURLEsc =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/locations";
      let LookUpHeadersEsc = this.$apikeyPost;
      let LookUpRequestEsc = {
        RequestType: "EscEdit",
        LocationDict: [
          {
            Location: this.editLocBuildingName,
            EscalationName: this.editLocEscName,
            EscalationEmail: this.editLocEscEmail,
            EscalationTel: this.editLocEscTele,
            Company: this.clCompany,
          },
        ],
      };

      axios
        .post(LookUpURLEsc, LookUpRequestEsc, LookUpHeadersEsc)
        .then((response) => {
          response;
          this.buttonCooldown = false;

          alert("Location has been edited");
          this.resetForm();
        });
    },

    deviceSubmit() {
      this.buttonCooldown = true;

      let EmailHPAdd = {
        ToEmail: "support@haloprotect.online",
        EmailText:
          "Hello, \\n\\nThe following Clarence Device has been requested.\\n\\n" +
          "Location:" +
          " " +
          this.contactLocation +
          "\\n\\nNumber Of Devices:" +
          " " +
          this.DeviceRequestNo +
          "\\n\\nUser Requesting:" +
          " " +
          this.userName +
          "\\n\\nSent from Seraph Protect",
        EmailSubject: "New Device Request ",
      };
      let EmailPosturl =
        "https://d9py0urct8.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/emailgateway";
      let EmailPostHeaders = this.$apikeyPost;
      axios
        .post(EmailPosturl, EmailHPAdd, EmailPostHeaders)
        .then((response) => {
          response;
          this.buttonCooldown = false;

          this.hideModal("DeviceRequest");
          this.resetForm();
          alert("Devices have been requested");
        })
        .catch((err) => {
          "Error: ===", err;
        });
    },

    removeLocation() {
      this.buttonCooldown = true;

      if (this.BMULocationRemove == "") {
        this.buttonCooldown = false;

        alert("Please select a location from the dropdown");
      } else {
        let LookUpURLEditLoc =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/locations";
        let LookUpHeadersEditLoc = this.$apikeyPost;
        let LookUpRequestEditLoc = {
          RequestType: "BMURemoveLoc",
          LocationDict: [
            { Location: this.BMULocationRemove.id, UserURN: this.UserURN },
          ],
        };

        axios
          .post(LookUpURLEditLoc, LookUpRequestEditLoc, LookUpHeadersEditLoc)
          .then((response) => {
            response;
            this.buttonCooldown = false;

            alert("Location Access has been removed");
            this.HistoryNote = "Removed Location";
            this.HistorySubmit();
            this.hideModal("RemoveLocation");
          });
      }
    },

    HistorySubmit() {
      this.buttonCooldown = true;

      let current = new Date();
      let HistoryDate =
        current.getFullYear() +
        "-" +
        (current.getMonth() + 1) +
        "-" +
        current.getDate();
      let HistoryTime =
        current.getHours() +
        ":" +
        current.getMinutes({ minimumIntegerDigits: 2 }) +
        ":" +
        current.getSeconds({ minimumIntegerDigits: 2, useGrou0ping: false });

      let LookUpURLHist =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/adminhistory";
      let LookUpHeadersHist = this.$apikeyPost;
      this.LookUpRequest = {
        UserURN: this.UserURN,
        HistoryDate: HistoryDate,
        HistoryTime: HistoryTime,
        HistoryNote: this.HistoryNote,
        ProfilePortal: this.UserProfile,
      };

      axios
        .post(LookUpURLHist, this.LookUpRequest, LookUpHeadersHist)
        .then((response) => {
          response;
          this.buttonCooldown = false;
        });
    },

    LookUpSubmit: function(Lookup) {
      this.buttonCooldown = true;

      if (Lookup == "BMUDeactivate") {
        let LookUpUrlBMU =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/sulookups";
        let LookUpHeadersBMU = this.$apikeyPost;
        this.LookUpRequest = {
          RequestType: "BoardMemberUser",
          RequestVariable: "",
          FirstName: this.UserFirstNameSearch,
          LastName: this.UserSurnameSearch,
          UserURN: "",
        };

        axios
          .post(LookUpUrlBMU, this.LookUpRequest, LookUpHeadersBMU)
          .then((response) => {
            response;
            this.buttonCooldown = false;

            if (response.data.Values == "Invalid Name") {
              this.buttonCooldown = false;

              alert("Please ensure the name entered is correct");
            } else if (response.data.Values[1] == null) {
              this.bmuList = "";
              this.bmuList = response.data.Values;
              this.bmuSelection = [];
              this.bmuToDelete = {};
              this.bmuSelection.push({
                UserURN: this.bmuList[0][0],
                Name: this.bmuList[0][1],
                Status: this.bmuList[0][2],
                Locations: this.bmuList[0][3],
              });
              this.bmuToDelete = this.bmuSelection[0];

              this.hideModal("BMUDeactivateModal");
              this.selectedAction = "DeactBMU";
              this.UserFirstNameSearch = "";
              this.UserSurnameSearch = "";
            } else if (response.data.Values[1] != "") {
              this.bmuList = "";
              this.bmuList = response.data.Values;
              for (let i = 0; i < this.bmuList.length; i++) {
                /*  var QuoteStr1 = this.clientList[i][0] */
                this.bmuListArray.push({
                  UserURN: this.bmuList[i][0],
                  Name: this.bmuList[i][1],
                  Status: this.bmuList[i][2],
                  Locations: this.bmuList[i][3],
                });
              }
              this.hideModal("BMUDeactivateModal");
              this.showModal("BMUSelectionModal");
            }

            this.deactclURN = response.data.Values[0][0];
            this.deactclFName = response.data.Values[0][1];
            this.deactclLName = response.data.Values[0][2];
            this.deactclDept = response.data.Values[0][3];
            this.deactclLoc = response.data.Values[0][6];
            this.hideModal("ClientDeactivateModal");
            this.DivID = "Client Deactivate";
          });
      } else if (Lookup === "BMUSelectLocModal") {
        let LookUpUrlBMU =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/sulookups";
        let LookUpHeadersBMU = this.$apikeyPost;
        this.LookUpRequest = {
          RequestType: "BoardMemberUser",
          RequestVariable: "",
          FirstName: this.UserFirstNameSearch,
          LastName: this.UserSurnameSearch,
          UserURN: this.BMUUserURN,
        };

        axios
          .post(LookUpUrlBMU, this.LookUpRequest, LookUpHeadersBMU)
          .then((response) => {
            if (response.data.Values == "Invalid Name") {
              this.buttonCooldown = false;

              alert("Please ensure the name entered is correct");
            } else if (response.data.Values[1] == null) {
              this.buttonCooldown = false;
              this.bmuList = "";
              this.bmuList = response.data.Values;
              this.bmuSelection = [];
              this.bmuToAddLoc = {};
              this.bmuSelection.push({
                UserURN: this.bmuList[0][0],
                Name: this.bmuList[0][1],
                Status: this.bmuList[0][2],
                Locations: this.bmuList[0][3],
              });
              this.bmuToAddLoc = this.bmuSelection[0];

              this.hideModal("BMUSelectLocModal");
              this.selectedAction = "AddLocation";
              this.UserFirstNameSearch = "";
              this.UserSurnameSearch = "";
            } else if (response.data.Values[1] != "") {
              this.buttonCooldown = false;
              this.bmuList = "";
              this.bmuList = response.data.Values;
              for (let i = 0; i < this.bmuList.length; i++) {
                /*  var QuoteStr1 = this.clientList[i][0] */
                this.bmuListArray.push({
                  UserURN: this.bmuList[i][0],
                  Name: this.bmuList[i][1],
                  Status: this.bmuList[i][2],
                  Locations: this.bmuList[i][3],
                });
              }
              this.hideModal("BMUDeactivateModal");
              this.showModal("BMUSelectionModal");
            }

            // this.deactclURN = response.data.Values[0][0];
            // this.deactclFName = response.data.Values[0][1];
            // this.deactclLName = response.data.Values[0][2];
            // this.deactclDept = response.data.Values[0][3];
            // this.deactclLoc = response.data.Values[0][6];
            // this.hideModal("ClientDeactivateModal");
            // this.DivID = "Client Deactivate";
          });
      }
    },
    regionLookUp() {
      this.buttonCooldown = true;

      (this.regionArray = []),
        (this.regionList = ""),
        (this.addNewLocationButton = true);

      let LookUpUrlExistingRegionLocation =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/sulookups";
      let LookUpHeadersRegionLocation = this.$apikeyPost;
      this.LookUpRequest = {
        RequestType: "RegionCountry",
        RequestVariable: this.bmuCountry.id,
      };
      axios
        .post(
          LookUpUrlExistingRegionLocation,
          this.LookUpRequest,
          LookUpHeadersRegionLocation
        )
        .then((response) => {
          this.buttonCooldown = false;

          this.regionList = response.data.Values;

          for (let i = 0; i < this.regionList.length; i++) {
            var QuoteStr4 = this.regionList[i][0];
            this.regionArray.push({
              id: QuoteStr4,
              Region: this.regionList[i][1],
            });
          }
        });
    },

    locationLookUp() {
      this.buttonCooldown = true;

      (this.buildingArray = []), (this.buildingList = "");
      let LookUpUrlLocation =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/sulookups";
      let LookUpHeadersLocation = this.$apikeyPost;
      this.LookUpRequest = {
        RequestType: "LocationRegion",
        RequestVariable: this.bmuRegion.id,
      };
      axios
        .post(LookUpUrlLocation, this.LookUpRequest, LookUpHeadersLocation)
        .then((response) => {
          this.buttonCooldown = false;

          this.buildingArray = response.data.Values;
          this.addNewLocationButton = false;
        });
    },
  },

  mounted() {
    let UserAccessGroup = localStorage.getItem("profileportal");
    if (UserAccessGroup == null) {
      this.$router.push("/");
    }

    /* Location Look Up */

    let LookUpUrlExistingLocation =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/sulookups";
    let LookUpHeadersExistingLocation = this.$apikeyPost;
    this.LookUpRequest = { RequestType: "Location", RequestVariable: "" };
    axios
      .post(
        LookUpUrlExistingLocation,
        this.LookUpRequest,
        LookUpHeadersExistingLocation
      )
      .then((response) => {
        this.locationList = response.data.Values;

        for (let i = 0; i < this.locationList.length; i++) {
          var QuoteStr4 = this.locationList[i][0];
          this.locationArray.push({
            id: QuoteStr4,
            Address: this.locationList[i][1],
            BuildingName: this.locationList[i][2],
            Country: this.locationList[i][3],
            Region: this.locationList[i][4],
            EscalationName: this.locationList[i][5],
            EscalationEmail: this.locationList[i][6],
            EscalationPhone: this.locationList[i][7],
            Company: this.locationList[i][8],
          });
        }
      });

    /* Country Look Up */

    let LookUpUrlExistingCountryLocation =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/sulookups";
    let LookUpHeadersCountryLocation = this.$apikeyPost;
    this.LookUpRequest = { RequestType: "Country", RequestVariable: "" };
    axios
      .post(
        LookUpUrlExistingCountryLocation,
        this.LookUpRequest,
        LookUpHeadersCountryLocation
      )
      .then((response) => {
        this.countryList = response.data.Values;

        for (let i = 0; i < this.countryList.length; i++) {
          var QuoteStr4 = this.countryList[i][0];
          this.countryArray.push({
            id: QuoteStr4,
            Country: this.countryList[i][1],
          });
        }
      });
  },

  data() {
    return {
      DivID: "",
      fName: "",
      lName: "",
      locationsArray: [],
      clCompany: localStorage.getItem("Company"),
      clDept: "",
      clLocation: "",
      clEmail: "",
      clURN: "",
      UserFirstNameSearch: "",
      UserSurnameSearch: "",
      deactclURN: "",
      deactclFName: "",
      deactclLName: "",
      deactclDept: "",
      deactclLoc: "",
      locAddress: "",
      locTele: "",
      locEscEmail: "",
      locEscName: "",
      locFloor: "",
      locBuildingName: "",
      locArea: "",
      locations: "",
      location: "",
      filteredlocations: "",
      editLocAddress: "",
      editLocBuildingName: "",
      editLocArea: "",
      editLocEscName: "",
      editLocEscEmail: "",
      editLocEscTele: "",
      contactLocation: this.$Location,
      DeviceRequestNo: "",
      userName: this.$FullName,
      BMULocationRemove: "",
      UserURN: this.$UserURN,
      CountriesArray: [],

      CountriesList: [],

      messageforNewLocationEmail: "",
      selectedSearch: "",
      UserProfile: this.$ProfilePortal,
      selectedAction: "",

      locationArray: [],
      locationList: "",

      countryList: "",
      countryArray: [],
      bmuCountry: "",

      regionArray: [],
      regionList: "",
      bmuRegion: "",
      buildingArray: [],
      buildingList: "",
      bmuLocationToAdd: "",
      bmuLocationtoSubmit: [],
      bmuEmail: "",
      bmuLocationSubmitDisplayObject: [],
      addNewLocationButton: true,
      bmuURN: "",
      bmuToDelete: "",
      bmuSelection: "",
      bmuList: "",
      bmuListArray: [],
      buttonCooldown: false,
      bmuToAddLoc: "",
      BMUUserURN: "",
    };
  },

  watch: {
    location() {
      this.filterLocations();
    },
    bmuCountry() {
      this.regionLookUp();
    },
    bmuRegion() {
      this.locationLookUp();
    },
    buttonCooldown() {
      this.btnCooldown();
    },
  },
};
</script>

<style scoped>
input[type="text"],
input[type="date"],
select {
  width: 100%;

  padding: 7px 7px 7px 7px;

  border: solid 1px rgba(200, 200, 200, 0.5);

  border-radius: 15px;

  background-color: rgb(245, 245, 245);
}

div {
  float: left;
  width: 100%;
  padding: 10px;
}

.container-fluid {
  border-style: none;
}

.card-body {
  border-style: none;
}

.collapse.show {
  border-style: none;
}

.container {
  border-style: none;
}

.row {
  border-style: none;
}
li {
  width: 100%;
}
input {
  margin-bottom: 8px;
}

input[type="number" i] {
  width: 30%;
}

.Auto {
  border: none;
  padding: none;
  margin: none;
}
.AutoDrop {
  width: 130%;
  text-align: left;
  float: right;
}

.locationAutoFill {
  border: none;
  padding: none;
  margin: none;
}

.locationAutoFillSpan {
  border: none;
  width: 50%;
  margin-left: 29%;
}

.locationAutoFillSpan li {
  background-color: whitesmoke;
}

.HandwashLocationDropdown {
  border: none;
  padding: none;
  margin: none;
}

.LocationHandwashAutoFillSpan {
  border: none;
  padding-left: 30%;
}

.LocationHandwashAutoFillSpan ul {
  width: 35%;
}

#AGPortalUser {
  margin-left: 10px;
}

.AutoDropDown {
  border: none;
  margin: none;
  padding: none;
}

.EditLocationAutoFillSpan {
  border: none;
}
.EditLocationAutoFillSpan ul {
  border: none;
  margin-left: 1%;
}

.EditLocationAutoFillSpan li {
  background: white;
}

.EditLocationDropdown {
  border: none;
  padding: none;
  margin: none;
}

#StaffRoleHide {
  border: none;
}
#LocationHide {
  border: none;
}

#DropdownAGRFIDRole {
  margin-left: 6px;
}

.lightText {
  text-align: center;
}

.LocationUnitAutoFillSpan {
  border: none;
}
.LocationUnitAutoFillSpan ul {
  border: none;
  margin-left: 10%;
}

.LocationUnitAutoFillSpan li {
  background: white;
}
.LocationDropdown {
  border: none;
}

#SubmitButtons {
  border: none;
  text-align: center;
}
.EditLocationDropdown input {
  margin-left: -5px;
}

#CenterButtons {
  text-align: center;
  border: none;
  padding: none;
  margin: none;
}

.tablinksActive {
  width: 25%;
}
.tablinks {
  border-right: 0.5px solid rgb(220, 220, 220);
  border-left: 0.5px solid rgb(220, 220, 220);
  width: 25%;
}

div.tab,
div.tabBottom {
  padding: 0;
}

.tablinksClientAdminActive {
  width: 50%;
}

.tablinksClientAdmin {
  width: 50%;
  border-right: 0.5px solid rgb(220, 220, 220);
  border-left: 0.5px solid rgb(220, 220, 220);
}

div.tabcontent {
  padding: 0;
}

.tablinksDeviceAdminActive {
  width: 25%;
}

.tablinksDeviceAdmin {
  width: 25%;
  border-right: 0.5px solid rgb(220, 220, 220);
  border-left: 0.5px solid rgb(220, 220, 220);
}

/* New Tabs -------------------------------------- New Tabs */

.reportTabLeft,
.reportTab {
  font-size: 14px;
  width: 33.3%;
  border-top: solid 1px rgb(200, 200, 200);
  border-left: solid 0.5px rgb(200, 200, 200);
  border-right: solid 0.5px rgb(200, 200, 200);
}

.reportTabRight {
  border-top: solid 1px rgb(200, 200, 200);
  border-left: solid 0.5px rgb(200, 200, 200);
  border-right: solid 0.5px rgb(200, 200, 200);
  font-size: 14px;
  width: 33.3%;
}

.reportTabActiveLeft,
.reportTabActiveRight {
  font-size: 14px;
  width: 33.3%;
}

.reportTabActive {
  width: 33.3%;
  font-size: 14px;
}

.reportTabActiveLeft:hover,
.reportTabActiveRight:hover,
.reportTabActive:hover {
  background-color: var(--TabActiveHoverColor);
}

.reportTabLeft:hover,
.reportTabRight:hover,
.reportTab:hover {
  background-color: var(--TabHoverColor);
}
.AdminButton:hover {
  border-style: solid;
  border-color: white;
  color: white;
  padding: 7px 16px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 14px;
  font-weight: bold;
  margin: 4px 2px;
  cursor: pointer;
  border-radius: 10px;
  background-color: black;
}
.AdminButton {
  border-style: solid;
  border-color: white;
  color: white;
  padding: 7px 16px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 14px;
  font-weight: bold;
  margin: 4px 2px;
  cursor: pointer;
  border-radius: 10px;
  background-color: black;
}

.Dropdownautofill {
  padding: 0 !important;
  margin: 0 !important;
}

.autofillButton {
  padding: 0;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  font-size: 0.8rem;
}
</style>
